module.exports = __webpack_public_path__ + "img/addTextNum4.402296d2.png";